export const FaqPageId = 'FaqPageId';

export enum FaqPageAttributes {
  HEADLINE = 'faqHeadline',
  HEADLINE_ELEMENT = 'faqHeadlineElement',
  SUBJECT_PARENT_PAGE = 'faqSubjectParentPage',
}
